<template>
	<van-tabbar v-model="currentActive" @change="onChangeTabBar" active-color="#EB2D16" inactive-color="#000000" style="height: 68px">
		<van-tabbar-item>
			<!-- 首页 -->
			<span>{{ $t("tabbar.pandapass") }}</span>
			<template #icon="props">
				<img :src="`/static/tabbar/index${props.active ? '_active' : ''}.png`" />
			</template>
		</van-tabbar-item>

		<van-tabbar-item>
			<!-- 数字人民币 -->
			<span>{{ $t("tabbar.ecny") }}</span>
			<template #icon="props">
				<img :src="`/static/tabbar/e_cny${props.active ? '_active' : ''}.png`" />
			</template>
		</van-tabbar-item>

		<van-tabbar-item class="center-tab">
			<!-- 新增的圆形导航项 -->
			<template #icon="props">
				<div class="center-icon-wrapper">
					<img :src="`/static/tabbar/qr_icon${props.active ? '_active' : ''}.png`" />
				</div>
			</template>
		</van-tabbar-item>

		<van-tabbar-item>
			<!-- 商城 -->
			<span>{{ $t("tabbar.shop") }}</span>
			<template #icon="props">
				<img :src="`/static/tabbar/shop${props.active ? '_active' : ''}.png`" />
			</template>
		</van-tabbar-item>

		<van-tabbar-item>
			<!-- 我的 -->
			<span>{{ $t("tabbar.my") }}</span>
			<template #icon="props">
				<img :src="`/static/tabbar/my${props.active ? '_active' : ''}.png`" />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
	export default {
		name: "TabBar",
		props: {
			active: {
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				currentActive: 0,
				tabRoutes: [
					{ path: "/", name: "Home" },
					{ path: "/ecny", name: "Ecny" },
					{ path: "/center", name: "Center" },
					{ path: "/shop", name: "Shop" },
					{ path: "/my", name: "My" },
				],
			};
		},
		watch: {
			active: {
				handler(newVal) {
					this.currentActive = newVal;
				},
				immediate: true,
			},
		},
		methods: {
			// 底部导航切换事件
			onChangeTabBar(index) {
				this.$emit("tab-change", index);
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.center-tab) {
		.van-tabbar-item__icon {
			position: relative;
			top: -15px; // 向上突出
		}
	}

	.center-icon-wrapper {
		width: 56px;
		height: 56px;
		border: 4px solid #fff;
		border-radius: 50%; // 圆形
		background: linear-gradient(135deg, #eb2d16, #ff6b35); // 渐变背景
		display: flex;
		align-items: center;
		justify-content: center;
		// box-shadow: 0 4px 12px rgba(235, 45, 22, 0.3); // 阴影效果
		position: relative;
		top: -5px; // 额外向上突出
		z-index: 9;

		img {
			width: 28px;
			height: 28px;
			filter: brightness(0) invert(1); // 图标变白色
		}
	}

	// 当第三个tab激活时的样式
	:deep(.center-tab.van-tabbar-item--active) {
		.center-icon-wrapper {
			background: linear-gradient(135deg, #ff6b35, #eb2d16);
			// box-shadow: 0 6px 16px rgba(235, 45, 22, 0.4);
			transform: scale(1.02);
		}
	}
</style>
